module.exports = __webpack_public_path__ + "img/users-alt.0115f2d1.svg";